import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { AppNotifications, RootState, TCb } from "../../../../models";
import { QuotationService } from "../../../../services";
import { NotificationActions } from "../../../../store/actions";
import QuotationDetailPresenter from "./QuotationDetail.presenter";
import { loadCallback } from "../../../../utils";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./QuotationDetail.type";
import { withRouter } from "react-router-dom";

class QuotationDetailContainer extends Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      detailData: this.props.initial,
      quotationDetail: []
    };
  }

  onLoadQuotationDetail = (quotationId: string, cb?: TCb) => {
    QuotationService.getQuotationHistory(quotationId)
      .then((res) => {
        if (res && res.data?.data) {
          this.setState({
            quotationDetail: res.data.data
          },
            () => {
              loadCallback(cb?.success);
            }
          );
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Load data failed",
          });
          this.setState({
            quotationDetail: [],
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Load data failed",
        });
        this.setState({
          quotationDetail: [],
        });
      });
  };

  componentDidMount = () => {
    this.onLoadQuotationDetail(this.props.quotationId!);
  }

  render() {
    return (
      <QuotationDetailPresenter
        {...this.props}
        {...this.state}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({}),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions), dispatch),
    })
  )(QuotationDetailContainer)
);
